import ZonesTab from "@features/stock/components/ZonesTab";
import { requirePermission } from "@lib/permissions/guards";
import { createFileRoute } from "@tanstack/react-router";
import { Grid3x3 } from "lucide-react";

export const Route = createFileRoute("/_app/stock/zones")({
  staticData: {
    title: "Zones",
    icon: Grid3x3,
    tab_icon: Grid3x3,
    permission: "stock.zones.view",
    module: "stock",
    section: "Stock",
    order: 47,
    showInTab: true,
    showInNav: true,
    showInBreadcrumb: true,
  },
  loader: requirePermission("stock.zones.view"),
  component: ZonesTab,
});
